import ChangeEmailScreen from 'features/myVaro/screens/PersonalDetails/ChangeEmail/ChangeEmailScreen';
import React from 'react';

export default function ChangeEmail() {
  return <ChangeEmailScreen />;
}
